import { Component, Input, OnInit } from '@angular/core';
import { AnaliseDesconto } from '../models/analise-desconto';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AnaliseDescontoService } from '../services/analise-desconto.service';
import { CarregandoService } from '../services/carregando.service';
import { NotificacaoService } from '../services/notificacao.service';
import { AnaliseDescontoStatus } from '../models/enum';

@Component({
  selector: 'app-historico-analise-desconto',
  templateUrl: './historico-analise-desconto.component.html',
  styleUrls: ['./historico-analise-desconto.component.scss']
})
export class HistoricoAnaliseDescontoComponent implements OnInit {

  @Input() idCupom: string;
  @Input() mostrarCmv: boolean;

  analisesDoPedido: AnaliseDesconto[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  AnaliseDescontoStatus = AnaliseDescontoStatus;

  constructor(private carregandoService: CarregandoService, private analiseDescontoService: AnaliseDescontoService,
    private notificacaoService: NotificacaoService
  ) { }

  ngOnInit() {
    this.buscarAnalisesDoPedido();
  }

  buscarAnalisesDoPedido() {
    this.carregandoService.mostra('buscarAnalisesDoPedido');
    this.analiseDescontoService.consultarAnalisesPorIdCupom(this.idCupom).subscribe(dados => {
      this.analisesDoPedido = dados;
      this.carregandoService.esconde('buscarAnalisesDoPedido');
    }, (erro) => {
      this.carregandoService.esconde('buscarAnalisesDoPedido');
      this.notificacaoService.erro(erro);
    });
  }
}
